export interface AppMetadata {
  activationPending?: boolean;

  [key: string]: any;
}

export interface OrgUnit {
  name: string;
  type: string;
  apt?: string;
  nmlsNumber?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  county?: string;
  logoUrl?: string;
  displayName?: string;
  url?: string;
}

export interface UserMetadata {
  companyName?: string;
  name?: string;
  phoneNumber?: string;

  [key: string]: any;
}

export class User {
  id?: any;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  profileImage?: string;
  phoneNumber?: string;
  phone?: string;
  WizeRoles?: any[];
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  email_verified?: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  app_metadata?: AppMetadata;
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  user_metadata?: UserMetadata;
  metadata?: any;
  WizeOrgUnitId?: number;
  WizeOrgUnit?: OrgUnit;
  type?: string;
  isCurrentUser?: boolean;
  LoanOfficer?: any;
  Loans?: any[];
}
